export const NFSE_NBS_OPTIONS: any[] = [
    { "value": "0", "label": "Não Selecionado" },
    { "value": "118025000", "label": "118025000 - Serviços de guarda e escolta armada" },
];

export const NFSE_NBS_OPERACAO_COD_OPTIONS = [
    { "value": "0", "label": "Não Selecionado" },
    { "value": "030101", "label": "030101 - Serviço prestado fisicamente sobre a pessoa ou fruído presencialmente por pessoa física - Estabelecimento do fornecedor como local da prestação" },
];

export const NFSE_NBS_CST_OPTIONS: any[] = [
    { "value": "0", "label": "Não Selecionado" },
    { "value": "000", "label": "000 - Tributação integral" },
    { "value": "010", "label": "010 - Tributação com alíquotas uniformes" },
    { "value": "011", "label": "011 - Tributação com alíquotas uniformes reduzidas" },
    { "value": "200", "label": "200 - Alíquota reduzida" },
    { "value": "220", "label": "220 - Alíquota fixa" },
    { "value": "221", "label": "221 - Alíquota fixa proporcional" },
    { "value": "222", "label": "222 - Redução de Base de Cálculo" },
    { "value": "400", "label": "400 - Isenção" },
    { "value": "410", "label": "410 - Imunidade e não incidência" },
    { "value": "510", "label": "510 - Diferimento" },
    { "value": "515", "label": "515 - Diferimento com redução de alíquota" },
    { "value": "550", "label": "550 - Suspensão" },
    { "value": "620", "label": "620 - Tributação monofásica" },
    { "value": "800", "label": "800 - Transferência de crédito" },
    { "value": "810", "label": "810 - Ajustes" },
    { "value": "811", "label": "811 - Ajustes de IBS na ZFM" },
    { "value": "820", "label": "820 - Tributação em documento específico" },
    { "value": "830", "label": "830 - Exclusão de base de cálculo" },
];

export const NFSE_NBS_CLASS_TRIB_OPTIONS: any[] = [
    { "value": "0", "label": "Não Selecionado" },
    { "value": "000001", "label": "000001 - Situações tributadas integralmente pelo IBS e CBS." },
    { "value": "000002", "label": "000002 - Exploração de via" },
    { "value": "000003", "label": "000003 - Regime automotivo - projetos incentivados (art. 311)" },
    { "value": "000004", "label": "000004 - Regime automotivo - projetos incentivados (art. 312)" },
    { "value": "000005", "label": "000005 - Operação com EAC destinado à mistura com gasolina A, mas com saída do biocombustível com destinação diversa" },
];
